import { createApi, fakeBaseQuery } from "@reduxjs/toolkit/query/react";
import {
  getActivityLogs,
  deleteOldActivityLogs,
  ACTIVITY_ACTIONS,
  ACTION_LABELS,
  ENTITY_TYPES,
} from "../../firebase";

export const activityLogsApi = createApi({
  reducerPath: "activityLogsApi",
  baseQuery: fakeBaseQuery(),
  tagTypes: ["ActivityLog"],
  endpoints: (builder) => ({
    // Get activity logs with pagination and filters
    getActivityLogs: builder.query({
      async queryFn({ clinicId, therapistId, action, entityType, startDate, endDate, cursor, pageSize = 50 }) {
        try {
          const result = await getActivityLogs(clinicId, {
            therapistId,
            action,
            entityType,
            startDate,
            endDate,
            cursor,
            pageSize,
          });
          return { data: result };
        } catch (error) {
          console.error("[CK-7060] Error fetching activity logs:", {
            errorCode: "CK-7060",
            errorMessage: error.message,
            clinicId,
            therapistId,
            action,
            entityType,
            timestamp: new Date().toISOString(),
          });
          return { error: { message: error.message } };
        }
      },
      providesTags: [{ type: "ActivityLog", id: "LIST" }],
    }),

    // Delete old activity logs (admin operation)
    deleteOldActivityLogs: builder.mutation({
      async queryFn({ clinicId, daysOld = 2555 }) {
        try {
          const deletedCount = await deleteOldActivityLogs(clinicId, daysOld);
          return { data: { deletedCount } };
        } catch (error) {
          console.error("[CK-7061] Error deleting old activity logs:", {
            errorCode: "CK-7061",
            errorMessage: error.message,
            clinicId,
            daysOld,
            timestamp: new Date().toISOString(),
          });
          return { error: { message: error.message } };
        }
      },
      invalidatesTags: [{ type: "ActivityLog", id: "LIST" }],
    }),
  }),
});

export const {
  useGetActivityLogsQuery,
  useDeleteOldActivityLogsMutation,
} = activityLogsApi;

// Re-export constants for use in components
export { ACTIVITY_ACTIONS, ACTION_LABELS, ENTITY_TYPES };

